import { NewProjectAssignmentData } from '@modules/HappinessModule/interfaces/NewProjectAssignmentData';
import { FlagFormFieldsNewProjectAssignment } from '@modules/HappinessModule/pages/FlagPage/components/FlagForm/constants/FlagFormFields';
import { getCurrentSeniority } from '@modules/HappinessModule/pages/FlagPage/pages/EditFlagFormPage/helpers/getFlagPageState';
import { Grid } from '@mui/material';
import { format, parseISO } from 'date-fns';
import { FC } from 'react';
import { FlagFieldBlockPreview } from '../../../FlagFieldBlockPreview';

interface Props {
  newProjectAssignmentData: NewProjectAssignmentData;
}

export const NewHomeProjectFoundPreview: FC<Props> = ({
  newProjectAssignmentData: {
    project,
    nearestEval,
    workload,
    currentSeniority,
    startDate,
    evaluationNotes,
    timeOffNotes,
    compensationAdjustmentAt,
  },
}) => {
  const firstRow = [
    {
      label: FlagFormFieldsNewProjectAssignment.project.label,
      value: project.name,
    },
    {
      label: FlagFormFieldsNewProjectAssignment.startDate.label,
      value: format(parseISO(startDate), 'dd MMM yyyy'),
    },
    {
      label: FlagFormFieldsNewProjectAssignment.workload.label,
      value: workload,
    },
  ];

  const secondRow = [
    {
      label: FlagFormFieldsNewProjectAssignment.currentSeniority.label,
      value: getCurrentSeniority(currentSeniority),
    },
    {
      label: FlagFormFieldsNewProjectAssignment.nearestEval.label,
      value: format(parseISO(nearestEval.date), 'dd MMM yyyy'),
    },
  ];

  return (
    <Grid container rowGap="24px">
      <Grid container xs={12}>
        {firstRow.map((item, index) => (
          <Grid item xs={2} key={index}>
            <FlagFieldBlockPreview label={item.label} value={item.value} />
          </Grid>
        ))}
      </Grid>
      <Grid container xs={12}>
        {secondRow.map((item, index) => (
          <Grid item xs={2} key={index}>
            <FlagFieldBlockPreview label={item.label} value={item.value} />
          </Grid>
        ))}
      </Grid>
      {timeOffNotes && (
        <Grid item xs={12}>
          <FlagFieldBlockPreview label={FlagFormFieldsNewProjectAssignment.timeOffNotes.label} value={timeOffNotes} />
        </Grid>
      )}
      {evaluationNotes && (
        <Grid item xs={12}>
          <FlagFieldBlockPreview
            label={FlagFormFieldsNewProjectAssignment.evaluationNotes.label}
            value={evaluationNotes}
          />
        </Grid>
      )}
      {compensationAdjustmentAt && (
        <Grid item xs={12}>
          <FlagFieldBlockPreview
            label={FlagFormFieldsNewProjectAssignment.compensationAdjustmentAt.label}
            value={format(parseISO(compensationAdjustmentAt), 'dd MMM yyyy')}
          />
        </Grid>
      )}
    </Grid>
  );
};
